import config from '../config';
import {
  Email,
  EmailType,
  GetEmails_UserFragment,
  Maybe,
  useUserEmailsQuery,
} from '../generated/graphql';

type UserEmailData = {
  emails: Email[] | undefined;
  verifiedCorporateEmails: Email[] | undefined;
  verifiedViewerEmailTypes: EmailType[] | undefined;
};

export function getUserEmails(
  data: Maybe<GetEmails_UserFragment>
): UserEmailData {
  const userEmails = data?.emails;
  const verifiedCorporateEmails = userEmails?.filter(
    email =>
      email.type === 'CORPORATE' &&
      (email.verified || // Do not require emails to be verified in dev/CI envs
        ['development', 'integration', 'devprod'].includes(
          config.ENVIRONMENT_NAME
        ))
  );
  const verifiedViewerEmailTypes = userEmails
    ?.filter(e => e.verified)
    .map(e => e.type);
  return {
    emails: userEmails,
    verifiedCorporateEmails,
    verifiedViewerEmailTypes,
  };
}

export function useUserEmails(): UserEmailData {
  const {data} = useUserEmailsQuery();

  return getUserEmails(data?.viewer ?? null);
}
